import { useEffect, useState } from 'react';
import Sidebar from '@common/Sidebar'
import Header from '@common/Header';
import BottomMenu from '@common/BottomMenu'
import Chat from '@common/Chat';
import classNames from "classnames";
import setSettingsFromServer from '@/helpers/setSettingsFromServer'
import s from './Layout.css';
import { useIsMinimizedMenu } from '@/hooks/useIsMinimizedMenu';

const Layout = ({ children }) => {
  const isMinimizedMenu = useIsMinimizedMenu();

  const [settings, setSettings] = useState({})
  useEffect(() => {
    setSettingsFromServer(setSettings)
  }, [])
  const chatEnabled = settings?.isChatEnabled === '1'

  return <div className={classNames('app-wrapper', {['app-wrapper-menu-minimized']: isMinimizedMenu} , s.sideWrapper)} >
    <Sidebar />
    <Header />
    {children}
    <BottomMenu />
    {chatEnabled && <Chat />}
  </div>
}

export default Layout;
